module.exports = __webpack_public_path__ + "img/iconProjectTelphone.80622668.svg";